<template>
  <div class="ioc-alarm__warp">
    <alarmList
      ref="alarmList"
      :addBtn="addBtn"
      :data="cacheAlarmList"
      :styles="{ top: '0px' }"
      :prop="prop"
      flag="emergencyRecordCode"
      @clickAlarm="alarmItemClick"
      @handleAddBtn="handleManual"
      @nextPage="loadMoreAlarm"
    ></alarmList>
    <!-- <div class="manual-reserve" :class="!handleAddBtn && 'show'">
      <el-button
        type="primary"
        v-auth="'/reserveImplement:add'"
        @click="handleManual"
        >手动预案</el-button
      >
    </div> -->
    <!-- right详情--管理告警和没有关联告警详情 -->
    <div class="ioc-alarm__drawer" :class="{ expand: rightDetail }">
      <div class="blur-bg map-blur-panel"></div>
      <div class="ioc-drawer__header">
        <span>预案详情 </span>
      </div>
      <el-scrollbar class="flex-auto ioc-alarm__scrollbar detailBgColor">
        <div v-if="currentAlarmDetail.subSystem == '12'" style="padding: 10px 15px">
          <img class="noImg" style="height: 160px; width: 100%" src="../images/sos.png" />
        </div>
        <div v-if="currentAlarmDetail.subSystem == '5'">
          <el-carousel style="height: 120px; overflow: hidden; margin-bottom: 10px">
            <el-carousel-item
              v-for="item in (
                currentAlarmDetail.alarmSnapUrl ||
                currentAlarmDetail.picUrl ||
                ''
              ).split(',')"
              :key="item"
            >
              <img
                class="lookPhoto"
                :src="Bus.imgPath(item)"
                style="width: 100%; height: 120px; cursor: pointer"
                @click="showViewer"
                onerror="this.src='/images/theme/newDark/default.png'"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 消防告警  告警基本信息-->
        <div class="ioc-alarm__drawer__title" v-if="currentAlarmDetail.subSystem == '4'">
          告警基本信息
        </div>
        <div
          class="content-container"
          v-if="currentAlarmDetail.subSystem == '4'"
        >
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark mb10">
                告警类型：
                <span :class="showColor(currentAlarmDetail.commonAlarmType)">{{
                  currentAlarmDetail.commonAlarmTypeLabel
                }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark mb10">
                设备告警类型：
                <span>{{ currentAlarmDetail.alarmTypeLabel }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark mb10">
                告警时间：{{ currentAlarmDetail.alarmTime | moment }}
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark mb10">
                告警级别：
                <span :class="alarmColor(currentAlarmDetail.alarmLevel)">
                  {{ currentAlarmDetail.alarmLevel | dic("SENU017") }}
                </span>
              </div>
            </el-col>
            <el-col :span="24" class="mb10">
              <div class="grid-content bg-purple-dark" style="line-height:26px" v-if="currentAlarmDetail.desc">
                告警描述：{{ currentAlarmDetail.desc }}
              </div>
              <div v-else class="grid-content bg-purple-dark">
                告警描述：
                <span v-if="currentAlarmDetail.buildingName"
                  >在{{ currentAlarmDetail.buildingName }}位置，{{
                    currentAlarmDetail.subDeviceMark | dic("SENU094")
                  }}上报
                  <span
                    v-if="currentAlarmDetail.commonAlarmType"
                    :class="showColor(currentAlarmDetail.commonAlarmType)"
                    >{{ currentAlarmDetail.commonAlarmTypeLabel }}</span
                  >
                </span>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 告警详情 -->
        <div class="ioc-alarm__drawer__title">
          {{
            currentAlarmDetail.subSystem == "12"
              ? "一键求救-"
              : currentAlarmDetail.subSystem == "5"
              ? "烟火-"
              : ""
          }}告警详情
        </div>
        <div
          class="ioc-alarm__drawer__card"
          v-if="
            currentAlarmDetail.subSystem == '5' || currentAlarmDetail.subSystem == '12'
          "
        >
          <alarmDetails :detail="currentAlarmDetail"></alarmDetails>
        </div>
        <div
          class="content-container"
          v-if="currentAlarmDetail.subSystem == '4'"
        >
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark mb10">
                主机类型：{{ currentAlarmDetail.deviceType | dic("SENU087") }}
                <span
                  v-if="
                    currentAlarmDetail.deviceType ||
                    currentAlarmDetail.parentFactoryName ||
                    currentAlarmDetail.factoryName
                  "
                  >(</span
                >
                {{
                  currentAlarmDetail.subDeviceMark
                    ? currentAlarmDetail.parentFactoryName
                    : currentAlarmDetail.factoryName
                }}
                <span
                  v-if="
                    currentAlarmDetail.deviceType ||
                    currentAlarmDetail.parentFactoryName ||
                    currentAlarmDetail.factoryName
                  "
                  >)</span
                >
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark mb10">
                主机名称：{{
                  currentAlarmDetail.subDeviceMark
                    ? currentAlarmDetail.parentDeviceName
                    : currentAlarmDetail.deviceName
                }}
                <span
                  v-if="
                    currentAlarmDetail.parentDeviceName ||
                    currentAlarmDetail.deviceName ||
                    currentAlarmDetail.parentThirdAlarmDevId
                  "
                  >(</span
                >
                {{ currentAlarmDetail.parentThirdAlarmDevId }}
                <span
                  v-if="
                    currentAlarmDetail.parentDeviceName ||
                    currentAlarmDetail.deviceName ||
                    currentAlarmDetail.parentThirdAlarmDevId
                  "
                  >)</span
                >
              </div>
            </el-col>
            <el-col :span="24" v-if="currentAlarmDetail.subDeviceMark">
              <div class="grid-content bg-purple-dark mb10">
                部件名称：{{ currentAlarmDetail.deviceName }}
                <span
                  v-if="
                    currentAlarmDetail.componentThirdAlarmDevId &&
                    currentAlarmDetail.deviceName
                  "
                  >(</span
                >
                {{ currentAlarmDetail.componentThirdAlarmDevId }}
                <span
                  v-if="
                    currentAlarmDetail.componentThirdAlarmDevId &&
                    currentAlarmDetail.deviceName
                  "
                  >)</span
                >
              </div>
            </el-col>
            <el-col :span="24" v-if="currentAlarmDetail.subDeviceMark">
              <div class="grid-content bg-purple-dark mb10">
                部件类型：{{ currentAlarmDetail.subDeviceMark | dic("SENU094") }}
              </div>
            </el-col>
            <!-- <el-col :span="24" v-if="currentAlarmDetail.subDeviceMark">
              <div class="grid-content bg-purple-dark mb10">
                回路：{{ currentAlarmDetail.loopThirdAlarmDevId }}
              </div>
            </el-col>
            <el-col :span="24" v-if="currentAlarmDetail.subDeviceMark">
              <div class="grid-content bg-purple-dark mb10">
                分机号：{{ currentAlarmDetail.childThirdAlarmDevId }}
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark mb10">
                IP地址：{{
                  currentAlarmDetail.subDeviceMark
                    ? currentAlarmDetail.parentIp
                    : currentAlarmDetail.ip
                }}
              </div>
            </el-col> -->
            <el-col :span="24">
              <div class="grid-content bg-purple-dark mb10">
                报警所在位置：{{ currentAlarmDetail.buildingName }}
              </div>
            </el-col>
          </el-row>
        </div>

        <!--应急卡信息 -->
        <div class="ioc-alarm__drawer__title">应急卡信息 {{ reserve.buildingName }}</div>
        <div class="ioc-alarm__drawer__card">
          <el-table :data="emergencyCardList" style="width: 100%">
            <el-table-column prop="cardName" label="处置卡" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="deviceName" label="设备" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileCode" label="文件">
              <template slot-scope="scope">
                <img
                  :src="Bus.imgPath(scope.row.fileCode)"
                  @click="showViewer"
                  onerror="this.src='/images/theme/newDark/default.png'"
                  style="height: 40px; width: 50px; cursor: pointer"
                />
              </template>
            </el-table-column>

            <el-table-column prop="desc" label="描述" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
        <!-- 流程预览 -->
        <div class="ioc-alarm__drawer__title">
          {{ $t("reserveImplement.title.reserveSteps") }}
        </div>
        <div class="ioc-alarm__drawer__card flex scroll-x">
          <div>
            <div class="reserve-info">
              <div class="reserve-name show-ellipsis">
                流程名称： {{ reserve.emergencyPlanName }}
              </div>
              <div class="reserve-select" v-if="reserve.status == 1">
                <el-button
                  type="text"
                  class="iconfont icon-task-all"
                  @click="openReserveSelect"
                  >{{ $t("reserveImplement.label.reserveSelect") }}</el-button
                >
              </div>
            </div>
            <div class="reserve-steps">
              <el-timeline>
                <el-timeline-item
                  v-for="(step, index) in reserveList"
                  type="primary"
                  :key="index"
                  >{{ step.step | dic("SENU073006") }}</el-timeline-item
                >
              </el-timeline>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div class="ioc-alarm__drawer__btns">
        <el-button @click="handleCloseRight" type="info">取消</el-button>
        <el-button @click="submitDispose" type="primary">{{
          $t("reserveImplement.button.response")
        }}</el-button>
      </div>
    </div>
    <!-- 手动添加预案 -->
    <div class="ioc-alarm__drawer" :class="{ expand: rightEdit }">
      <div class="blur-bg map-blur-panel"></div>
      <div class="ioc-drawer__header">
        <div class="slot-title">
          <span v-if="reserve.status != 2">手动预案</span>
          <span
            v-if="reserve.status == 2"
            :title="
            reserve.emergencyPlanName&&reserve.emergencyPlanName.length > 30 ? reserve.emergencyPlanName : ''
            "
            style="
              width: 100%;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            {{ reserve.emergencyPlanName }}
            {{ reserve.level | dic("SENU073002") }}
          </span>
        </div>
      </div>
      <el-scrollbar class="flex-auto ioc-alarm__scrollbar">
        <div class="detail-main">
          <div class="ioc-alarm__drawer__title">
            <div class="info-area device flexLF">
              <div class="info">
                <i class="required" v-if="reserve.status != 2">*</i>
                实时视频
              </div>
              <el-button type="info" v-if="reserve.status != 2" @click="openDeviceTree"
                >添加摄像机</el-button
              >
              <div
                v-if="reserve.status == 2"
                style="display: flex; cursor: pointer"
                @click="handleVideo('live')"
                title="实况"
              >
                {{ reserve.alarmDevName }}
                <img style="margin-left: 15px" src="../images/live.png" alt="" />
              </div>
            </div>
          </div>
          <div class="checkCarame flexLF" v-if="cameraList.length && reserve.status != 2">
            {{ cameraList[0].name }}
            <i class="el-icon-delete" style="cursor: pointer" @click="deleteCamera"></i>
          </div>
          <div class="ioc-alarm__drawer__title">
            <div class="info-area">
              <div class="info flexLF">
                <div>
                  <i class="required" v-if="reserve.status != 2">*</i>
                  {{ reserve.status == 2 ? "预案位置" : "选择位置" }}
                </div>
                <div>
                  <el-input
                    v-if="!reserve.longitude"
                    readonly
                    placeholder="请点击地图选择位置"
                  >
                  </el-input>
                  <div v-else>
                    <div style="padding: 6px">
                      经度:
                      {{ reserve.longitude }}
                    </div>
                    <div style="padding: 6px">
                      纬度:
                      {{ reserve.latitude }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ioc-alarm__drawer__title">
            <i class="required" v-if="reserve.status != 2">*</i>
            预案描述
          </div>
          <div class="ioc-alarm__drawer__card" style="margin-top: 0px">
            <div>
              <el-input
                v-if="reserve.status != 2"
                type="textarea"
                v-model="reserve.desc"
                :placeholder="$t('reserveImplement.placeholder.reserveDesc')"
                :maxlength="200"
                show-word-limit
                :autosize="{ minRows: 4 }"
              ></el-input>
              <div
                v-else
                :title="reserve.desc && reserve.desc.length > 100 ? reserve.desc : ''"
                style="
                  margin: 16px;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  overflow: hidden;
                  word-wrap: break-word;
                  -webkit-line-clamp: 5;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 5;
                "
              >
                {{ reserve.desc }}
              </div>
            </div>
          </div>
          <div class="ioc-alarm__drawer__title">
            {{ $t("reserveImplement.title.reserveSteps") }}
          </div>
          <div
            :class="[
              reserve.emergencyPlanName ? 'ioc-alarm__drawer__card' : '',
              'flex scroll-x',
            ]"
          >
            <div v-if="reserve.emergencyPlanName">
              <div class="reserve-info">
                <div
                  class="reserve-name show-ellipsis"
                  :title="
                    reserve.emergencyPlanName.length > 30 ? reserve.emergencyPlanName : ''
                  "
                >
                  {{ reserve.emergencyPlanName }}
                  {{ reserve.level | dic("SENU073002") }}
                </div>
                <div class="reserve-select" v-if="reserve.status != 2">
                  <!-- :disabled="parseInt(reserve.status) !== 1" -->
                  <el-button
                    type="text"
                    class="iconfont icon-task-all"
                    @click="openReserveSelect"
                    >{{ $t("reserveImplement.label.reserveSelect") }}</el-button
                  >
                </div>
              </div>
              <div class="reserve-steps">
                <el-timeline>
                  <!-- :type="parseInt(step.status) === 1 ? 'primary' : ''" -->
                  <el-timeline-item
                    v-for="(step, index) in reserveList"
                    type="primary"
                    :key="index"
                    >{{ step.step | dic("SENU073006") }}</el-timeline-item
                  >
                </el-timeline>
              </div>
            </div>
            <div v-else class="info-area device flexLF">
              <div class="ioc-alarm__drawer__title">
                <i class="required">*</i>
                选择预案
              </div>
              <el-button type="info" @click="openReserveSelect">添加预案</el-button>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <!--应急响应 -->
      <div class="ioc-alarm__drawer__btns">
        <el-button @click="handleCloseRight" type="info">取消</el-button>
        <el-button @click="submitDispose" type="primary">{{
          reserve.status != 2 ? "手动预案" : $t("reserveImplement.button.response")
        }}</el-button>
      </div>
    </div>
    <!-- </ioc-drawer> -->
    <!--展示资源大图-->
    <el-dialog
      :title="$t('realTimeAlarm.title.resourse')"
      :visible.sync="resourceDialogShow"
      width="540px "
      v-dialogDrag
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="resourceClose"
    >
      <!-- 该行数据currentResource，告警详情taskAlarmInfo都必须有 -->
      <resource-show
        ref="resourceDialog"
        :resourceUrl="currentResource"
        :alarmInfo="currentAlarmDetail"
      ></resource-show>
    </el-dialog>
    <!-- 选择预案流程 -->
    <el-dialog
      :visible="showSelect"
      width="560px"
      :before-close="close"
      custom-class="plan-list-select"
      :title="$t('reserveImplement.label.reserveSelect')"
    >
      <div>* 根据预案类型选择预案流程</div>
      <div class="select-content" style="height: 380px;justify-content: space-between;">
        <el-scrollbar class="scroll-bar diaBk" style="margin:12px 12px 0  0">
          <div class="title">预案类型</div>
          <div class="list">
            <div
              v-for="(item, i) in planList"
              :key="i"
              :title="item.label"
              :class="[
                'item show-ellipsis',
                item.value == selectType.value ? 'current' : '',
              ]"
              @click="getReserveList(item)"
            >
              {{ item.label }}
            </div>
          </div>
        </el-scrollbar>
        <el-scrollbar class="scroll-bar diaBk" style="margin:12px 0px 0  0">
          <div class="title">预案流程配置</div>
          <div v-show="currentSubList.length" class="list">
            <div
              v-for="(cur, j) in currentSubList"
              :key="j"
              :title="showLevelName(cur)"
              :class="['item show-ellipsis ', j === currentSubIndex ? 'current' : '']"
              @click="chooseReserve(j)"
            >
              {{ showLevelName(cur) }}
            </div>
          </div>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" type="info">{{ $t("base.button.cancel") }}</el-button>
        <el-button :disabled="currentSubIndex === -1" type="primary" @click="confirm">{{
          $t("base.button.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 摄像机列表 -->
    <el-dialog
      title="摄像机列表"
      :visible.sync="showTreeList"
      width="450px"
      v-dialogDrag
      :before-close="handleCloseDialog"
    >
      <div style="height: 450px">
        <area-device-tree ref="deviceTree"></area-device-tree>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
    <image-preview
      ref="imagePreview"
      @fastControl="fastControl"
      @hideOption="hideOption"
    />
  </div>
</template>
<script>
import alarmList from "@src/components/business/app-alarm/alarmList";
import alarmDetails from "../components/alarmDetail";
// import areaDeviceTree from "@src/modules/video/components/realTime/device-group-tree";
import areaDeviceTree from "../components/areaDeviceTree";
import { api } from "../api";
import { Dic, Cache, Bus, Base, Dates } from "$utils";
import resourceShow from "@src/components/business/app-resource-show-alarm";
import imgzn from "../images/no-img.jpg";
import imgen from "../images/Image not found.jpg";
import imagePreview from "../components/app-image-preview/index";
export default {
  components: {
    alarmList,
    alarmDetails,
    areaDeviceTree,
    resourceShow,
    imagePreview,
  },
  filters: {
    alarmName(alarmType, item) {
      const value = Dic.findByValue("SENU004005", alarmType);
      return item.deviceName ? value + "_" + item.deviceName : value;
    },
  },
  data() {
    return {
      addBtn: {
        show: true,
        text: "手动预案",
      },
      Bus,
      emergencyCardList: [],
      noImg: this.$i18n.locale === "zh_CN" ? imgzn : imgen,
      shezhiShow: true,
      noData: false,
      deviceList: [],
      reserve: {},
      reserveList: [],
      cameraList: [],
      cameraListbf: [],
      types: {
        image: "image",
        video: "video",
      },
      showSelect: false,
      showTreeList: false,
      planList: [], //预案类型列表
      selectType: {}, //当前选择预案类型
      currentSubIndex: -1, //当前所选预案下标
      currentSubList: [], //当前类型的预案列表
      drawPoint: [],
      alarm: {
        alarmId: "",
        desc: "",
        alarmState: "",
      },
      resouces: {
        types: [18], //_.map(Dic.find('SENU006'), 'value'),
        areas: [],
      },
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0,
      },
      ocx: {
        x: 1000,
        y: 400,
      },
      resoucesList: [],
      rightDetail: false,
      rightEdit: false,
      mapClick: false,
      currentAlarmDetail: {},
      alarmList: [],
      playOption: {
        videoSrc: "http://nebula-playback.qiniudn.com/test-playback/flv/sample.flv",
        deviceId: "1",
        cameraType: "",
        playId: "1000",
        posterSrc: "/images/theme/newDark/default.png",
      },
      prop: {
        name: "emergencyPlanName",
        type: "type",
        level: "alarmLevel",
        status: "status",
        groupName: "areaName",
        time: "activeTime",
      },
      formatter: {
        type: this.typeFormatter,
        level: this.levelFormatter,
        name: this.nameFormatter,
        time: this.timeFormatter,
      },
      cacheAlarmList: [],
      // alarmOption: alarmDetail(this),
      currentResource: [],
      resourceDialogShow: false,
      postionId: "position_red", // 地标
      currentDevice: "current_device", // 设备
      flickerAnimationTimer: null,
      flickerTime: 0,
      chooseDeviceDrawPoint: [],
      handleAddBtn: true,
      mapId: "handle-Res-position",
      reservePointId: "reservePointId", //预案详情点位
      handlePointId: "handlePointId", //手动打点
    };
  },
  watch: {},
  mounted() {
    this.handleAddBtn = false;
    if (this.$route && this.$route.query) {
      this.emergencyRecordID = this.$route.query.emergencyRecordID;
    }
    Dic.find("SENU073005").forEach((item) => {
      item.value = item.value + "";
      this.planList.push(item);
    });
    this.$map.showMap2D(() => {
      this.$map.MapInstance2D.initPage();
      this.getList(this.page);
    });
    // 初始化模块数据
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  methods: {
    showColor(val) {
      if (val == "4001") {
        return "colorRed";
      } else if (val == "4002") {
        return "colorYellow";
      } else if (val == "4005" || val == "4008" || val == "4009" || val == "40099") {
        return "colorBlue";
      } else if (val == "130103") {
        return "colorYellow";
      } else if (val == "130101") {
        return "colorRed";
      } else {
        return "";
      }
    },
    alarmColor(level) {
      let className = "";
      if (level === 1) {
        className = "instancys";
      }
      if (level === 2) {
        className = "severitys";
      }
      if (level === 3) {
        className = "generals";
      }
      if (level === 4) {
        className = "commons";
      }
      return className;
    },
    handleCloseDialog() {
      this.showTreeList = false;
    },
    showViewer(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    //查看图片全屏
    hideOption() {
      this.$refs.videoPlayer.isShow = false;
    },
    close() {
      this.showSelect = false;
    },
    // 选中预案
    confirm() {
      this.reserve.emergencyPlanCode = this.currentSubList[
        this.currentSubIndex
      ].emergencyPlanCode;
      this.reserve.emergencyPlanName = this.currentSubList[
        this.currentSubIndex
      ].emergencyPlanName;
      this.reserve.stepList = this.currentSubList[this.currentSubIndex].stepList;
      this.reserve.level = this.currentSubList[this.currentSubIndex].level;
      this.reserve.type = this.currentSubList[this.currentSubIndex].type;
      this.reserveList = [];
      this.reserve.stepList.forEach((el) => {
        this.reserveList.push({ step: el });
      });
      this.showSelect = false;
    },
    // 选择预案
    openReserveSelect() {
      if (this.planList.lenth == 0) {
        Dic.find("SENU073005").forEach((item) => {
          item.value = item.value + "";
          this.planList.push(item);
        });
      }
      if (this.reserve.alarmType) {
        this.selectType = {};
        this.currentSubList = [];
        Dic.find("SENU073005").forEach((item) => {
          if (item.value == this.reserve.alarmType) {
            this.getReserveList(item);
          }
        });
      }
      this.$nextTick(() => {
        this.showSelect = true;
      });
    },
    // 手动预案
    handleManual() {
      if (this.rightEdit) {
        this.handleCloseRight();
        setTimeout(() => {
          this.handleManual();
        }, 300);
        return;
      }
      this.reserve = {};
      this.reserveList = [];
      this.selectType = {};
      this.currentSubList = [];
      this.rightDetail = false;
      this.rightEdit = true;
      this.$map.MapInstance2D.setLayerVisibleById("CAMERA", false);
      let that = this;
      this.$map.MapInstance2D.getLocation((data) => {
        // 如果当前正在创建手动预案
        if (that.rightEdit) {
          that.addHandleIcon(data);
        }
      });
    },
    // 位置打点
    addHandleIcon(data) {
      console.log("当前正在创建手动预案，点击的位置为：", data);
      const position = [Number(data[0]), Number(data[1])];
      this.$set(this.reserve, "longitude", position[0]);
      this.$set(this.reserve, "latitude", position[1]);
      let handlePosition = [
        {
          id: this.mapId,
          coord: position,
          longitude: position[0],
          latitude: position[1],
          anchor: [11, 23],
          src: `images/theme/newDark/map/resource/position_red.png`,
        },
      ];
      this.$map.MapInstance2D.addMarket(handlePosition, this.handlePointId, () => {});
    },
    openReserve() {
      this.rightDetail = true;
      this.rightEdit = false;
    },
    // 选择摄像机
    openDeviceTree() {
      this.showTreeList = true;
      if (this.cameraList.length) {
        this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys([
          this.cameraList[0].id,
        ]);
      }
    },
    deleteCamera() {
      this.cameraList = [];
      this.showTreeList = false;
    },
    cancelDialog() {
      this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys([]);
      // this.cameraListbf = [];
      this.showTreeList = false;
    },
    // 确定摄像机
    submitDialog() {
      let checkCamera = this.$refs.deviceTree.checkCameraData;
      if (checkCamera.nodeType != "device") {
        this.$message.warning("请选择摄像机设备");
        return;
      }
      this.$refs.deviceTree.$refs.appDeviceGroupTree.setCheckedKeys([]);
      this.cameraList = [{ ...checkCamera }];
      this.showTreeList = false;
      this.$set(this.reserve, "alarmDevId", this.cameraList[0].id);
      // this.cameraListbf = [];
    },
    handlePlay() {
      this.playOption.deviceId = this.reserve.thirdAlarmDevId;
      this.playOption.playType = "live";
      const param = {
        deviceId: this.reserve.thirdAlarmDevId,
        protocol: window.systemConfig.MEDIA_TYPE,
      };
      this.$fetch(api.reserve.queryRealTimeVideoRtsp, param).then((res) => {
        if (res.success) {
          this.playOption.videoSrc = res.returnObj.url || this.playOption.videoSrc;
          this.playOption.deviceId = param.deviceId;
          this.$refs.player.startPlay();
        } else {
          this.$message.error(res.msgContent);
        }
      });
      // this.$refs.player.startPlay()
    },
    closeMapClick() {
      this.$map.MapInstance2D.destroyLocation();
    },
    chooseDeviceFromMap(event) {
      this.$map.MapInstance2D.addCircles({
        longitude: event[0],
        latitude: event[1],
        radius: 2000,
        id: new Date().getTime(),
      });
      let option = {
        deviceName: "",
        latitude: event[1] + "",
        longitude: event[0] + "",
      };
      this.$fetch(api.reserve.queryRegionalEquipmentTree, option).then((response) => {
        if (response.success) {
          this.closeMapClick();
          this.drawPoint = [];
          const pointsData = this.deviceDataPro(response.returnObj) || [];
          this.drawDevicePoint(pointsData);
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    deviceDataPro(devices, parentName) {
      let list = [];
      if (devices && devices.length) {
        devices.forEach((item) => {
          if (item.nodeType === "device") {
            list.push({
              areaName: parentName,
              ...item,
            });
          } else if (item.nodeType === "area") {
            list = list.concat(this.deviceDataPro(item.children, item.name));
          }
        });
      }
      return list;
    },
    drawDevicePoint(pointsData) {
      let img = "images/map/resource/camera.png";
      if (pointsData.length && pointsData[0].count) {
        img = "images/map/resource/position_blue.png";
      }
      pointsData.map((item, index) => {
        if (item.longitude && item.latitude && item.distance < 2000) {
          this.drawPoint.push({
            id: item.deviceId || "position_" + index,
            src: img,
            label: item.deviceName || item.count,
            thirdAlarmDevId: item.thirdCameraId || "",
            coord: [parseFloat(item.longitude), parseFloat(item.latitude)],
            attr: {
              alarmId: item.alarmId,
              imgIndex: 1,
              alarmLevel: item.alarmLevel,
              label: item.deviceName,
              thirdAlarmDevId: item.thirdCameraId || "",
              areaId: item.parentId,
              areaName: item.areaName,
              src: "images/map/alarm_state/" + item.alarmLevel + "_1.png",
              id: item.alarmDevId,
            },
          });
        }
      });
      this.drawPoint = Object.freeze(this.drawPoint);
      // this.deviceIconObj && this.deviceIconObj.refreshLayerByData();
      this.$map.MapInstance2D.clearPoint();
      this.$map.MapInstance2D.destroyLocation();
      this.$map.MapInstance2D.addMarket(this.drawPoint);
    },
    // 资源组件关闭
    resourceClose() {
      this.$refs.resourceDialog.stopVideo();
      this.resourceDialogShow = false;
    },
    // 显示资源
    enlargeResource(item) {
      this.resourceDialogShow = true;
      this.currentResource = [item];
    },
    clearFlickerAnimation() {
      let _self = this;
      if (_self.flickerAnimationTimer) {
        window.cancelAnimationFrame(_self.flickerAnimationTimer);
        _self.flickerAnimationTimer = null;
      }
    },
    // 关闭右侧弹窗（预案详情/手动预案）
    handleCloseRight() {
      this.rightDetail = false;
      this.rightEdit = false;
      this.$refs.alarmList.activeInfo = {};
      this.$map.MapInstance2D.removePoint(this.reservePointId);
      this.$map.MapInstance2D.removePoint(this.handlePointId);
      this.$map.MapInstance2D.setLayerVisibleById("CAMERA", true);
    },
    alarmImage(item) {
      const token = Cache.get("access_token");
      let url = "";
      switch (item.picResourceType) {
        case 1:
          url = `${api.bas.picStreamInfo}?resourceCode=${item.resourceCode}&ticket=${token}`;
          break;
        case 3:
          url = `${api.bas.picStreamInfo}?alarmId=${item.alarmId}&alarmType=${item.alarmType}&deviceId=${item.deviceId}&picResourceType=${item.picResourceType}&ticket=${token}`;
          break;
        case 4:
          url = `${api.bas.picStreamInfo}?alarmId=${item.alarmId}&alarmType=${item.alarmType}&picResourceType=${item.picResourceType}&ticket=${token}`;
          break;
        default:
          url = `${api.bas.picStreamInfo}?picResourceType=${item.picResourceType}&alarmType=${this.currentAlarmDetail.alarmType}&alarmId=${this.currentAlarmDetail.alarmId}&ticket=${token}&resourceCode=${item.resourceCode}`;
      }
      return url;
    },
    lookPhoto(item) {
      this.$refs["imagePreview"].open(item);
    },
    /*
     *@name: 快速布控
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-05-29 14:30:02
     */
    fastControl(data) {
      //   this.clearTips()
      this.$refs["imagePreview"].isShow = false;
      //   this.$store.dispatch('set_tab', 3)
      this.$nextTick(() => {
        this.$refs["rapidControlWindow"].imgData = data.file;
      });
    },
    // get左侧列表
    getList(page) {
      const _this = this;
      this.$fetch(
        api.reserve.queryEmergencyRecordList,
        Object.assign({
          pageNum: page.currentPage,
          pageSize: page.pageSize,
        })
      ).then((response) => {
        if (response && response.success) {
          if (page.currentPage === 1) {
            _this.cacheAlarmList = [];
          }
          let tempReserve = {};
          _this.alarmList = response.returnObj
            ? response.returnObj.list.filter((item) => {
                if (this.emergencyRecordID === item.emergencyRecordID) {
                  tempReserve = item;
                }
                return parseInt(item.status) !== 3;
              })
            : [];
          if (this.cacheAlarmList.length === 1000) {
            this.cacheAlarmList.splice(0, this.page.pageSize);
          }
          _this.cacheAlarmList = this.cacheAlarmList.concat(_this.alarmList);
          // _this.cacheAlarmList = _.orderBy(_this.cacheAlarmList, ['activeTime'], ['desc'])
          _this.page.total = response.returnObj ? response.returnObj.total : 0;
          if (_this.cacheAlarmList.length == 0) {
            this.noData = true;
            return;
          } else {
            this.noData = false;
          }
          this.reserve = tempReserve.emergencyRecordID
            ? tempReserve
            : this.cacheAlarmList[0];
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    showLevelName(cur) {
      // return `${cur.emergencyPlanName}    ${cur.levelName}`;
      return `${cur.emergencyPlanName}`;
    },
    chooseReserve(index) {
      this.currentSubIndex = index;
    },
    // 根据预类型获取预案流程
    getReserveList(row) {
      // console.log(row)
      // console.log(this.reserve)
      if (this.reserve.alarmType && row.value != this.reserve.alarmType) {
        this.$message.warning("预案类型暂不支持更改，请选择预案流程");
        return;
      }
      this.selectType = row;
      let params = {
        pageNum: 1,
        pageSize: 1000,
        status: '1',
        subSystemList: [this.selectType.value],
      };
      this.$fetch(api.reserve.getEmergencyPlanListByAlarmType, params).then(
        (response) => {
          if (response.success) {
            this.currentSubIndex = -1;
            this.currentSubList = response.returnObj.list.map((item) => {
              if (item.levelName) {
                return item;
              }
              item.levelName = Dic.findByValue("SENU073002", item.level);
              return item;
            });
          } else {
            this.$message({
              type: "error",
              message: response.msgContent,
            });
          }
        }
      );
    },
    // left 列表点击乎获取详情
    alarmItemClick(item) {
      if (this.rightEdit || this.rightDetail) {
        this.handleCloseRight();
        setTimeout(() => {
          this.alarmItemClick(item);
        }, 300);
        return;
      }
      // this.handleCloseRight();
      this.alarm.processDesc = "";
      this.emergencyCardList = [];
      const params = {
        emergencyRecordCode: item.emergencyRecordCode,
      };
      this.$fetch(api.reserve.queryEmergencyRecordDetail, params).then((res) => {
        if (res && res.success) {
          this.reserve = res.returnObj;
          console.log("预案详情", this.reserve);
          this.addHandlePoint(res.returnObj);
          this.reserveList = this.reserve.emergencyRecordStepList;
          if (this.reserve.emergencyCardList) {
            this.emergencyCardList = this.reserve.emergencyCardList.filter((s) => {
              return s;
            });
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 告警预案获取详情
    showDetail() {
      // 是否可以设置联动设备
      if (this.currentAlarmDetail.reportPersonName) {
        this.shezhiShow = false;
      } else {
        this.shezhiShow = true;
      }
      // 截取vcm的fileId,用于人脸告警大图详情展示
      let uuidIndex =
        this.currentAlarmDetail.alarmSnapUrl &&
        this.currentAlarmDetail.alarmSnapUrl.indexOf("fileUuid");
      let index =
        this.currentAlarmDetail.alarmSnapUrl &&
        this.currentAlarmDetail.alarmSnapUrl.indexOf("&");
      let fileId =
        this.currentAlarmDetail.alarmSnapUrl &&
        this.currentAlarmDetail.alarmSnapUrl.substring(uuidIndex + 9, index);
      // 图片展示 需要判断是否存在
      if (this.currentAlarmDetail.alarmSnapUrl) {
        this.currentAlarmDetail.pictureList = this.currentAlarmDetail.filePicSourceLists.filter(
          (item) => {
            if (item.picResourceType !== 2) {
              fileId && this.$set(item, "fileId", fileId);
              return {
                resourceCode: item.resourceCode,
                picResourceType: item.picResourceType,
              };
            }
          }
        );
        // 手动告警上传视频
        this.currentAlarmDetail.manuaAlarmPicList = this.currentAlarmDetail.filePicSourceLists.filter(
          (item) => {
            if (item.picResourceType == 2) {
              return {
                resourceCode: item.resourceCode,
                picResourceType: item.picResourceType,
                resourceName: item.resourceName,
              };
            }
          }
        );
        this.currentAlarmDetail = Object.freeze(this.currentAlarmDetail);
      }
      // 设备打点
      // this.setCurrentPosition();
    },
    // 清除选中状态
    clearPosition() {
      let positionIndex = this.chooseDeviceDrawPoint.findIndex(
        (item) => item.id == this.postionId
      );
      let currentDeviceIndex = this.chooseDeviceDrawPoint.findIndex(
        (item) => item.id == this.currentDevice
      );
      // 已有，移除
      if (currentDeviceIndex > -1) {
        this.chooseDeviceDrawPoint.splice(currentDeviceIndex, 1);
      }
      if (positionIndex > -1) {
        this.chooseDeviceDrawPoint.splice(positionIndex, 1);
      }
      //设置中心点位
      if (this.$map.MapInstance2D) {
        this.$map.MapInstance2D.clearPoint();
        this.$map.MapInstance2D.destroyLocation();
        this.$map.MapInstance2D.addMarket(this.chooseDeviceDrawPoint);
      }
    },
    // 预案打点
    addHandlePoint(item) {
      this.chooseDeviceDrawPoint = []; //备份预案打点信息
      let centerPoint = [Number(this.reserve.longitude), Number(this.reserve.latitude)];
      this.$map.MapInstance2D.positionByPoint(centerPoint);

      this.chooseDeviceDrawPoint.push({
        id: this.postionId,
        coord: centerPoint,
        anchor: [20, 20],
        longitude: Number(this.reserve.longitude),
        latitude: Number(this.reserve.latitude),
        alarmLevel: item.alarmLevel,
        src: item.alarmId
          ? `images/theme/${this.currentTheme}/map/alarm_state/${item.alarmLevel}_1.png`
          : `images/theme/newDark/map/resource/position_alarm.png`,
      });
      if (item.alarmId) {
        this.$map.MapInstance2D.addFlashMarket(
          this.chooseDeviceDrawPoint,
          this.reservePointId,
          () => {}
        );
      } else {
        this.$map.MapInstance2D.addMarket(
          this.chooseDeviceDrawPoint,
          this.reservePointId,
          () => {}
        );
      }

      if (item.alarmId) {
        // 告警触发--一键求救，火警，可燃气体
        const params = {
          alarmId: item.alarmId,
        };
        this.$fetch(api.alarm.getAlarmDetail, params).then((response) => {
          if (response && response.success) {
            this.currentAlarmDetail = response.returnObj;
            this.showDetail();
          } else {
            this.$message.error(
              response.msgContent || this.$t("historyAlarm.message.queryFailed")
            );
          }
          this.rightDetail = true;
        });
      } else {
        this.rightEdit = true;
      }
    },
    // 告警预案打点
    setCurrentPosition() {
      console.log(this.chooseDeviceDrawPoint);
      this.chooseDeviceDrawPoint = [];
      let center = [
        parseFloat(this.currentAlarmDetail.lng),
        parseFloat(this.currentAlarmDetail.lat),
      ];
      this.chooseDeviceDrawPoint.push({
        id: this.postionId,
        coord: center,
        anchor: [10, 12],
        srcMap: [
          `images/theme/light/map/alarm_state/${this.currentAlarmDetail.alarmLevel}_1.png`,
          `images/theme/light/map/alarm_state/${this.currentAlarmDetail.alarmLevel}_2.png`,
          `images/theme/light/map/alarm_state/${this.currentAlarmDetail.alarmLevel}_3.png`,
          `images/theme/light/map/alarm_state/${this.currentAlarmDetail.alarmLevel}_4.png`,
        ],
        imgIndex: 0,
        src: `images/theme/light/map/alarm_state/${this.currentAlarmDetail.alarmLevel}_1.png`,
      });
      if (this.$map.MapInstance2D) {
        this.$map.MapInstance2D.clearPoint();
        this.$map.MapInstance2D.destroyLocation();
        this.$map.MapInstance2D.addFlashMarket(
          this.chooseDeviceDrawPoint,
          "MAP_LAYER_alarm"
        );
      }
    },
    // 应急响应
    submitDispose() {
      console.log("---response---", this.reserve);
      if (parseInt(this.reserve.status) === 2) {
        this.$store.state.common.reserveDetail = this.reserve;
        this.$router.push({
          path: "/reserve/reserveProcess",
          query: {
            emergencyRecordCode: this.reserve.emergencyRecordCode,
          },
        });
      } else if (this.rightDetail) {
        // 非手动
        this.alarmDispose();
      } else if (this.rightEdit) {
        // 手动
        this.handleReserveDispose();
      }
    },
    // 告警预案right按钮
    alarmDispose() {
      if (
        !this.reserve.emergencyPlanCode ||
        !this.reserve.emergencyPlanName ||
        !this.reserve.level ||
        !this.reserve.type
      ) {
        this.$message.warning("请选择预案流程");
        return;
      }
      let params = {
        emergencyPlanCode: this.reserve.emergencyPlanCode,
        emergencyPlanName: this.reserve.emergencyPlanName,
        emergencyRecordCode: this.reserve.emergencyRecordCode,
        level: this.reserve.level,
        status: this.reserve.status,
        type: this.reserve.type,
      };
      this.$fetch(api.reserve.updateEmergencyRecord, params).then((response) => {
        if (response.success) {
          this.$store.state.common.reserveDetail = this.reserve;
          this.$router.push({
            path: "/reserve/reserveProcess",
            query: {
              emergencyRecordCode: this.reserve.emergencyRecordCode,
            },
          });
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    //手动预案rignt按钮
    handleReserveDispose() {
      if (!this.reserve.alarmDevId) {
        this.$message.warning("请选择添加摄像机");
        return;
      }
      if (!this.reserve.longitude || !this.reserve.latitude) {
        this.$message.warning("请选择位置");
        return;
      }
      if (!this.reserve.desc) {
        this.$message.warning(this.$t("reserveImplement.message.noDesc"));
        return;
      }
      if (
        !this.reserve.emergencyPlanCode ||
        !this.reserve.emergencyPlanName ||
        !this.reserve.level ||
        !this.reserve.type
      ) {
        this.$message.warning("请选择添加预案");
        return;
      }
      const params = {
        alarmDevId: this.reserve.alarmDevId, //摄像机id
        desc: this.reserve.desc, //描述
        emergencyPlanCode: this.reserve.emergencyPlanCode, //预案编号
        emergencyPlanName: this.reserve.emergencyPlanName, //预案名称
        latitude: this.reserve.latitude,
        longitude: this.reserve.longitude,
        level: parseInt(this.reserve.level),
        type: parseInt(this.reserve.type),
        // alarmType: this.selectType.value,
        subSystem: this.selectType.value,
        status: 2,
      };
      this.$fetch(api.reserve.handEmergency, params).then((response) => {
        if (response.success) {
          this.$router.push({
            path: "/reserve/reserveProcess",
            query: {
              emergencyRecordCode: response.returnObj,
            },
          });
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    // 滚动下一页
    loadMoreAlarm() {
      this.page.currentPage = this.page.currentPage + 1;
      this.getList(this.page);
    },
    // 手动预案视频直播
    handleVideo(type) {
      this.$app.AppInstance.handleMiniPlay({
        playType: type,
        playTitle: this.reserve.alarmDevName, //摄像机名称
        playId: this.reserve.thirdAlarmDevId, //摄像机id
      });
    },
    // 播放视频
    playVideo(type, item) {
      const startTime = Dates.dayjs(parseInt(this.currentAlarmDetail.startTime)).format(
        "YYYY/MM/DD HH:mm:ss"
      );
      const endTime = Dates.dayjs(parseInt(this.currentAlarmDetail.endTime)).format(
        "YYYY/MM/DD HH:mm:ss"
      );
      this.$refs.videoPlayer.open({
        playType: type,
        ocxVisible: true,
        cameraCode: item ? item.thirdDeviceId : this.currentAlarmDetail.thirdAlarmDevId,
        cameraName: item ? item.deviceName : this.currentAlarmDetail.deviceName,
        backStartTime: startTime,
        backEndTime: endTime,
        alarmTime: Dates.dayjs(parseInt(this.currentAlarmDetail.alarmTime)).format(
          "YYYY/MM/DD HH:mm:ss"
        ),
        x: 580,
        y: 200,
        z: 100,
      });
    },
    // 查看实时视频 录像
    viewVideo(type) {
      if (!this.currentAlarmDetail.thirdAlarmDevId) {
        this.$message.error(this.$t("realTimeAlarm.message.noDevice"));
        return;
      }
      if (
        type == "back" &&
        !this.currentAlarmDetail.startTime &&
        !this.currentAlarmDetail.endTime
      ) {
        this.$message.error(this.$t("realTimeAlarm.message.noPlan"));
        return;
      }
      this.playVideo(type);
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.manual-reserve {
  position: absolute;
  left: -360px;
  top: 10px;
  z-index: 2;
  @include set_animation(all);
  &.show {
    left: 360px !important;
  }
}

// @import "../style/alarm.scss";
.ioc-alarm__list__title {
  @include set_theme_color(background-color, top-menu-bg-color);
}
.ioc-drawer__header {
  // @include set_theme_color(background-color, top-menu-bg-color);
}
.flexLF {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}
.newColor {
  @include set_theme_color(background-color, blur-color);
}
.ioc-drawer__header .slot-title {
  position: relative;
  width: 100%;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ioc-alarm__drawer__card {
  // @include set_theme_color(background-color, map-panel-content);
}
.noData {
  // position: absolute;
  // top: 220px;
  // z-index: 100;
  text-align: center;
  font-size: 14px;
  margin-top: 70px;
}
.ioc-alarm__list {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ioc-alarm__scrollbar {
  flex: 1;
}
.ioc-alarm__drawer__btns {
  position: relative;
}
.ioc-alarm__warp .ioc-alarm__drawer {
  top: 0px;
  height: 100%;
}
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.detail-main {
  padding: 16px;
  @include set_theme_color(background-color, map-panel-content);
}
.checkCarame {
  padding: 12px;
  margin: 12px 0;
  @include set_theme_color(background-color, input-default-bg-color);
}
.diaBk {
  // background-color: #0d121c;
  @include set_theme_color(background-color, page-default-bg);
  .title {
    height: 32px;
    line-height: 32px;
    text-align: center;
    @include set_theme_color(background-color, input-disabled-bg-color);
  }
  .item {
    border-bottom: 1px solid #fff;
    &:hover {
      @include set_theme_color(background-color, input-disabled-bg-color);
    }
  }
  .current {
    @include set_theme_color(background-color, input-disabled-bg-color);
  }
}

.detailBgColor {
  @include set_theme_color(background-color, map-panel-content);
  :deep .el-scrollbar__view {
    margin: 10px 16px;
  }
}
.ioc-drawer__header .vue-cropper {
  background-image: none !important;
  background-color: #152942;
}
</style>
